"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = __importDefault(require("./actions"));
exports.default = (function (virtual) {
    var ac = actions_1.default(virtual);
    return function (action, data) {
        var act = ac[action];
        if (act) {
            return act(data);
        }
    };
});



// WEBPACK FOOTER //
// ./src/actions/send/index.ts